import React from 'react'

import {
  NameAndDobCollectionFormUI,
  NameAndDobCollectionFormValues,
} from '~/components/screens/NameAndDobCollectionFormUI'
import { useBffWebOnboardingCreateNewAccount } from '../utils'
import { useTenantConfigQuery } from '~/utils/useTenantConfigQuery'

/**
 * Authenticated version of the Name & DOB collection screen.
 */
const AuthenticatedNameDobCollection: React.FC = () => {
  const { data: tenantData, isLoading: tenantConfigLoading } = useTenantConfigQuery()
  const { handler: createAccount, loading: createAccountLoading } =
    useBffWebOnboardingCreateNewAccount()

  const tenantConsentForms = tenantData?.consentForms?.filter(
    consentForm => consentForm.needsSignature,
  )

  // Initialize form
  const initialValues: NameAndDobCollectionFormValues = {
    firstName: '',
    lastName: '',
    preferredName: '',
    dob: '',
    termsAndConditions: false,
    consentForms: [],
  }

  const handleSubmit = async (values: NameAndDobCollectionFormValues) => {
    // Add consent forms if terms accepted
    const consentForms = values.termsAndConditions ? tenantConsentForms?.map(f => f.id) || [] : []

    await createAccount({
      firstName: values.firstName,
      lastName: values.lastName,
      dob: values.dob,
      consentForms: consentForms,
      ...(values.preferredName && { preferredName: values.preferredName }),
    })
  }

  return (
    <NameAndDobCollectionFormUI
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isLoading={tenantConfigLoading || createAccountLoading}
    />
  )
}

export default AuthenticatedNameDobCollection
